// Internal list of HTML entities for escaping.
export default {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
};



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/_escapeMap.js
// module id = 270
// module chunks = 8